/**
 * Returns a CSS class fragment for the document thumbnail color, picked from the MIME type. Mirrors
 * the prototype's color-coded sticker style (invoice/contract/photo/...) without trying to match
 * specific document categories — we just bucket on top-level MIME family for v1.
 */
export function mimeColorClass(mime: string | undefined): string {
  if (!mime) return 'doc-thumb--other';
  const lower = mime.toLowerCase();
  if (lower.startsWith('image/')) return 'doc-thumb--image';
  if (lower === 'application/pdf') return 'doc-thumb--pdf';
  if (lower.startsWith('video/')) return 'doc-thumb--video';
  if (lower.startsWith('audio/')) return 'doc-thumb--audio';
  if (lower.startsWith('text/') || lower.includes('word') || lower.includes('document')) {
    return 'doc-thumb--text';
  }
  if (lower.includes('sheet') || lower.includes('excel') || lower.includes('csv')) {
    return 'doc-thumb--sheet';
  }
  return 'doc-thumb--other';
}
